import { Car } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Toggle chip for the "Home visit" search facet — narrows results to salons
 * that offer mobile (comes-to-you) service. Mirrors OnlineFacetChip's shape
 * and active styling; mounted in the search page facet row.
 */
interface MobileFacetChipProps {
  active: boolean;
  onToggle: () => void;
}

export function MobileFacetChip({ active, onToggle }: MobileFacetChipProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={active}
      className={[
        'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors',
        active
          ? 'bg-foreground text-background border-foreground'
          : 'bg-card text-foreground border-border/60 hover:border-foreground/40',
      ].join(' ')}
    >
      <Car className="w-3.5 h-3.5" aria-hidden="true" />
      {t('search.facets.mobileAvailable')}
    </button>
  );
}
